import { Button } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React, { Fragment, useState } from "react";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  leftButton: {
    marginRight: "auto",
  },
});

const TemplateUploadCreditNoteButton = () => {
  const [open, setOpen] = useState<boolean>(false);
  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label="Download Template Credit note"
        onClick={handleOpenDialog}
        className={classes.leftButton}
      />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          Template Import Mass Import Credit Note
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            1. You can download template for upload mass credit notes to system
            in this link below.
          </Typography>
          <Typography gutterBottom>
            <Link href="https://jane-prod-storage.s3.ap-southeast-1.amazonaws.com/templates/Template+Import+Credit+Note+V2.xlsx">
              Template Import Credit Note V2.xlsx
            </Link>
          </Typography>
          <br />
          <Typography gutterBottom>
            2. If doesnt have Deferral Code and Deferral Start Date and Invoice
            Reference Number, can fill in with "-" .
          </Typography>
          <Typography gutterBottom>
            3. If the column Description has more than <strong>90 characters</strong>, 
            it will be trimmed because MBC restricts Description length.
          </Typography>
          <Typography gutterBottom>
            4. After fill the sheet, export document to CSV format, then upload
            the document.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default TemplateUploadCreditNoteButton;
